export interface VideoItem {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  thumbnail: string;
  description: string;
  source: string;
  rating: number;
  year: number;
  region: string;
  director: string;
  actors: string[];
  updateInfo: string;
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { name: '电视剧', slug: 'dianshiju', icon: 'ri-tv-line' },
  { name: '电影', slug: 'dianying', icon: 'ri-film-line' },
  { name: '综艺', slug: 'zongyi', icon: 'ri-live-line' },
  { name: '动漫', slug: 'dongman', icon: 'ri-rocket-line' },
  { name: '纪录片', slug: 'jilupian', icon: 'ri-camera-lens-line' },
];

export const videos: VideoItem[] = [
  {
    id: 'v1',
    title: '长安十二时辰',
    category: '电视剧',
    categorySlug: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20night%20scene%20with%20lanterns%20and%20traditional%20architecture%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20warm%20golden%20tones%2C%20historical%20drama%20aesthetic%2C%20misty%20streets%20with%20figures%20in%20traditional%20clothing%2C%20epic%20scale%20composition&width=800&height=450&seq=taohua-v1&orientation=landscape',
    description: '唐朝上元节前夕，长安城陷入了一场惊天阴谋。死囚张小敬临危受命，与李必携手在十二时辰内拯救长安。',
    source: '香蕉视频',
    rating: 9.2,
    year: 2019,
    region: '中国大陆',
    director: '曹盾',
    actors: ['雷佳音', '易烊千玺', '周一围'],
    updateInfo: '已完结 · 48集全',
    isHot: true,
    isNew: false,
  },
  {
    id: 'v2',
    title: '流浪地球2',
    category: '电影',
    categorySlug: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20station%20with%20Earth%20visible%20through%20large%20window%2C%20sci-fi%20cinematic%20scene%2C%20blue%20and%20orange%20contrast%20lighting%2C%20astronauts%20working%20on%20panels%2C%20epic%20scale%2C%20dramatic%20composition&width=800&height=450&seq=taohua-v2&orientation=landscape',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的旅程，年轻一代挺身而出，展开争分夺秒的生死之战。',
    source: '糖豆视频',
    rating: 8.8,
    year: 2023,
    region: '中国大陆',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    updateInfo: '高清上线',
    isHot: true,
    isNew: true,
  },
  {
    id: 'v3',
    title: '狂飙',
    category: '电视剧',
    categorySlug: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dark%20rainy%20city%20street%20at%20night%20in%20China%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20crime%20drama%20aesthetic%2C%20two%20figures%20in%20silhouette%20facing%20each%20other%2C%20tense%20atmosphere%2C%20cinematic%20noir%20style&width=800&height=450&seq=taohua-v3&orientation=landscape',
    description: '一线刑警安欣与黑恶势力展开长达二十年的生死搏斗，扫黑过程中的惊心动魄，展现了正义与邪恶的较量。',
    source: '小蓝视频',
    rating: 9.5,
    year: 2023,
    region: '中国大陆',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐'],
    updateInfo: '已完结 · 39集全',
    isHot: true,
    isNew: false,
  },
  {
    id: 'v4',
    title: '斗罗大陆',
    category: '动漫',
    categorySlug: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Fantasy%20world%20with%20floating%20islands%20and%20magical%20glowing%20spirits%2C%20anime%20style%20art%2C%20young%20warrior%20with%20blue%20aura%20standing%20on%20cliff%2C%20dramatic%20sky%20with%20purple%20and%20gold%20clouds%2C%20epic%20adventure%20scene&width=800&height=450&seq=taohua-v4&orientation=landscape',
    description: '唐门外门弟子唐三，因偷学内门绝学为唐门所不容，跳崖明志后穿越到斗罗大陆，从此踏上武魂修炼之路。',
    source: '蓝莓视频',
    rating: 8.7,
    year: 2018,
    region: '中国大陆',
    director: '沈乐平',
    actors: ['沈磊', '程玉珠', '黄翔宇'],
    updateInfo: '连载中 · 更新至286集',
    isHot: false,
    isNew: false,
  },
  {
    id: 'v5',
    title: '你好，李焕英',
    category: '电影',
    categorySlug: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Warm%20nostalgic%201980s%20Chinese%20factory%20scene%2C%20mother%20and%20daughter%20laughing%20together%2C%20soft%20golden%20sunlight%2C%20vintage%20clothing%20and%20bicycles%2C%20heartwarming%20family%20comedy%20aesthetic%2C%20gentle%20bokeh%20background&width=800&height=450&seq=taohua-v5&orientation=landscape',
    description: '2001年的某一天，刚考上大学的贾晓玲意外穿越到1981年，与年轻时的母亲李焕英相遇，展开一段感人至深的亲情故事。',
    source: '香蕉视频',
    rating: 9.0,
    year: 2021,
    region: '中国大陆',
    director: '贾玲',
    actors: ['贾玲', '张小斐', '沈腾'],
    updateInfo: '高清上线',
    isHot: false,
    isNew: false,
  },
  {
    id: 'v6',
    title: '三体',
    category: '电视剧',
    categorySlug: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Mysterious%20radio%20telescope%20array%20under%20starry%20night%20sky%2C%20alien%20signal%20visualization%20as%20glowing%20waves%2C%20sci-fi%20thriller%20atmosphere%2C%20dark%20cosmic%20background%2C%20red%20planet%20visible%20in%20distance%2C%20cinematic%20wide%20shot&width=800&height=450&seq=taohua-v6&orientation=landscape',
    description: '纳米科学家汪淼被警官史强带到联合作战中心，潜入神秘组织"科学边界"，在 investigation 中接触到一个名为"三体"的虚拟现实游戏。',
    source: '糖豆视频',
    rating: 8.5,
    year: 2023,
    region: '中国大陆',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾'],
    updateInfo: '第一季完结 · 30集全',
    isHot: true,
    isNew: true,
  },
  {
    id: 'v7',
    title: '种地吧',
    category: '综艺',
    categorySlug: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Young%20people%20farming%20in%20beautiful%20Chinese%20countryside%2C%20golden%20wheat%20fields%2C%20bright%20sunny%20day%2C%20group%20of%20friends%20laughing%20while%20working%2C%20reality%20show%20aesthetic%2C%20warm%20natural%20lighting%2C%20pastoral%20scenery&width=800&height=450&seq=taohua-v7&orientation=landscape',
    description: '十位少年用190天时间，在142亩土地上播种、灌溉、施肥、收获，真实运营农场，感受土地的力量。',
    source: '小蓝视频',
    rating: 9.1,
    year: 2023,
    region: '中国大陆',
    director: '',
    actors: ['蒋敦豪', '鹭卓', '李耕耘'],
    updateInfo: '第二季热播中',
    isHot: true,
    isNew: true,
  },
  {
    id: 'v8',
    title: '满江红',
    category: '电影',
    categorySlug: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20courtyard%20mansion%20at%20night%20with%20red%20lanterns%2C%20narrow%20corridors%20and%20stone%20walls%2C%20mysterious%20soldiers%20in%20traditional%20armor%2C%20historical%20thriller%20aesthetic%2C%20deep%20shadows%20and%20warm%20candlelight%2C%20cinematic%20suspense&width=800&height=450&seq=taohua-v8&orientation=landscape',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信不翼而飞。小兵张大与亲兵营副统领孙均被裹挟进巨大阴谋之中。',
    source: '蓝莓视频',
    rating: 8.3,
    year: 2023,
    region: '中国大陆',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译'],
    updateInfo: '高清上线',
    isHot: false,
    isNew: false,
  },
  {
    id: 'v9',
    title: '中国奇谭',
    category: '动漫',
    categorySlug: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20style%20animation%20scene%2C%20mythical%20fox%20demon%20in%20bamboo%20forest%2C%20traditional%20Chinese%20art%20aesthetic%2C%20misty%20mountain%20background%2C%20elegant%20flowing%20brushwork%2C%20moonlight%20filtering%20through%20trees&width=800&height=450&seq=taohua-v9&orientation=landscape',
    description: '由八个植根于中国传统文化的独立故事组成，涵盖多种美术风格与制作手法，展现中式想象力。',
    source: '香蕉视频',
    rating: 9.4,
    year: 2023,
    region: '中国大陆',
    director: '於水',
    actors: [],
    updateInfo: '已完结 · 8集全',
    isHot: true,
    isNew: false,
  },
  {
    id: 'v10',
    title: '航拍中国 第四季',
    category: '纪录片',
    categorySlug: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20spectacular%20Chinese%20mountain%20landscape%20with%20winding%20rivers%2C%20dramatic%20clouds%2C%20terraced%20fields%2C%20documentary%20cinematography%2C%20golden%20hour%20light%2C%20vast%20panoramic%20scale%2C%20natural%20wonder&width=800&height=450&seq=taohua-v10&orientation=landscape',
    description: '以空中视角俯瞰中国，立体化展示中国历史人文、地理风貌及社会形态，让观众以一个全新的角度看到美丽中国。',
    source: '糖豆视频',
    rating: 9.6,
    year: 2023,
    region: '中国大陆',
    director: '余乐',
    actors: [],
    updateInfo: '已完结 · 11集全',
    isHot: false,
    isNew: true,
  },
  {
    id: 'v11',
    title: '漫长的季节',
    category: '电视剧',
    categorySlug: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Northeast%20China%20small%20town%20in%20autumn%2C%20old%20factory%20buildings%2C%20golden%20leaves%20falling%2C%20retro%201990s%20aesthetic%2C%20melancholy%20atmosphere%2C%20train%20tracks%20winding%20through%20town%2C%20nostalgic%20cinematic%20composition&width=800&height=450&seq=taohua-v11&orientation=landscape',
    description: '在小城桦林，出租司机王响做梦也没想到，自己还有机会遇到二十年前那个最漫长的秋天里遇到的人。一桩悬案，改变了几个家庭的命运。',
    source: '小蓝视频',
    rating: 9.5,
    year: 2023,
    region: '中国大陆',
    director: '辛爽',
    actors: ['范伟', '秦昊', '陈明昊'],
    updateInfo: '已完结 · 12集全',
    isHot: true,
    isNew: false,
  },
  {
    id: 'v12',
    title: '孤注一掷',
    category: '电影',
    categorySlug: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dark%20underground%20call%20center%20with%20rows%20of%20computers%2C%20tense%20thriller%20atmosphere%2C%20fluorescent%20lighting%2C%20people%20working%20under%20pressure%2C%20crime%20drama%20aesthetic%2C%20closed%20windowless%20room%2C%20gritty%20realistic%20style&width=800&height=450&seq=taohua-v12&orientation=landscape',
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。为了离开，两人准备向赌徒阿天和其女友小雨下手套现完成业绩。',
    source: '蓝莓视频',
    rating: 8.0,
    year: 2023,
    region: '中国大陆',
    director: '申奥',
    actors: ['张艺兴', '金晨', '王传君'],
    updateInfo: '高清上线',
    isHot: false,
    isNew: true,
  },
];

export const getVideosByCategory = (slug: string): VideoItem[] => {
  return videos.filter((v) => v.categorySlug === slug);
};

export const getHotVideos = (): VideoItem[] => {
  return videos.filter((v) => v.isHot);
};

export const getNewVideos = (): VideoItem[] => {
  return videos.filter((v) => v.isNew);
};

export const getVideoById = (id: string): VideoItem | undefined => {
  return videos.find((v) => v.id === id);
};

export const getCategoryName = (slug: string): string => {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
};